import { defineMessages } from 'react-intl';
export var messages = defineMessages({
  altPressLogos: {
    id: 'press-testimonial.press.logos',
    defaultMessage: 'press company logos'
  },
  altQuoteLogo: {
    id: 'press-testimonial.quote.logo',
    defaultMessage: '{source} logo'
  },
  pressHeader: {
    id: 'press-testimonial.header',
    defaultMessage: 'In the press'
  },
  quoteNYT: {
    id: 'press-testimonial.quote.nyt',
    defaultMessage: 'ClassPass offers a considerable leap in efficiency and convenience, paired with a price cut that seems too good to be true.'
  },
  quoteWG: {
    id: 'press-testimonial.quote.wg',
    defaultMessage: 'ClassPass’s monthly memberships are a great value, considering most classes cost upwards of $30 each at retail pricing or drop-ins.'
  }
});